import { useNavigate } from 'react-router-dom';

import { Layout } from '@components/Layout';
import { paths } from '@constants/paths';
import { Details } from '@features/details/Details';
import { useLoader } from '@hooks/useLoader';
import { withProfiler } from '@services/sentry/withProfiler';
import { RequestState } from '@src/types/index';

const DetailsPageUnwrapped = () => {
  const navigate = useNavigate();
  const { requestStatus } = useLoader();

  if (requestStatus === RequestState.loading) {
    return null;
  }

  return (
    <Layout
      title="Your details"
      onBack={() => navigate(paths.bundle)}
      backButtonLabel="Back to bundle"
    >
      <Details />
    </Layout>
  );
};

const DetailsPage = withProfiler(DetailsPageUnwrapped);

export default DetailsPage;
